import React, { useState } from 'react';
import {Form, Input, Modal, Row, Col, Button} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiCross, BiPencil, BiTrash, BiX} from "react-icons/bi";
import {PostRol} from "../../../dao/root/PostRol";

interface IngredientModalProps {
    element: object;
    visible: boolean;
    page: string;
    onClose: (value: boolean) => void;

    id_usu_log : string
}

const UsuarisModal: React.FC<IngredientModalProps> = ({ element, visible, page, onClose , id_usu_log}) => {
    const [form] = Form.useForm();

    async function handleSubmit () {
        const nom = await form.getFieldValue('nom');
        const id = await form.getFieldValue('id');
        await PostRol(id, nom, page, id_usu_log);
        await onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <Modal
            title="Crear/Editar Rol"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1000}
        >
            <Form form={form} initialValues={element} >
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={2}>
                    </Col>
                    <Col span={2}>
                        <Form.Item label="id" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="nom" name="nom">
                            <Input type="text" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default UsuarisModal;
